import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';
import { dasherize } from '@ember/string';

export default Factory.extend({
  id: () => faker.string.uuid(),
  name: () => dasherize(faker.commerce.department().toLowerCase()),
});
